import http from '@/plugins/http';
import PublicHolidaysTransformer from '../../transformers/data/publicHolidays';

export default (params) => new Promise((res, rej) => {
  http.get('/v3/public-holidays', { params })
    .then((response) => {
      res(PublicHolidaysTransformer.fetchCollection(response.data));
    })
    .catch((error) => {
      rej(error);
    });
});
